import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { Amplify } from "aws-amplify";
import awsconfig from "./aws-exports";
import LoginPage from "./component/LoginPage";
import RegisterPage from "./component/SignupPage";
import ConfirmEmailPage from "./component/ConfirmationPage";
import ProtectedRoute from "./component/ProtectedRoute";
import Sidebar from "./component/user/Sidebar";
import ApproverDashboard from "./pages/ApproverDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import "./toastr.css";
import "./index.css";
import LogoutPage from "./component/LogoutPage";

Amplify.configure(awsconfig);

const App = () => {
  return (
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route element={<ProtectedRoute isAuthPage={true} />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          </Route>

          {/* Protected Routes */}
          <Route element={<ProtectedRoute isAuthPage={false} />}>
            {/* User Dashboard */}
            <Route
              path="/user/dashboard"
              element={<Sidebar isSidebarOpen={true} toggleSidebar={() => {}} />}
            />
            {/* Approver Dashboard */}
            <Route path="/approver/*" element={<ApproverDashboard />} />
            {/* Admin Dashboard */}
            <Route path="/admin/*" element={<AdminDashboard />} />
          </Route>

          {/* Default Route */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
  );
};

export default App;
